import Typography from "aldoo-ra/Typography"
import { CheckIcon } from "@heroicons/react/24/outline"

/**
 * Shared shell for the pricing cards (One-Time, Pro). Title/subtitle/price/
 * button are passed as nodes since their content and behavior differ per
 * plan; this component only owns the wrapper, badge ribbon and highlights
 * list markup common to both.
 */
export default function PlanCard({ className = "", badge, title, subtitle, price, button, highlights = [], children }) {
  return (
    <div className={`relative flex flex-col h-full rounded-3xl p-6 pt-8 transition-shadow hover:shadow-lg ${className}`}>
      {badge && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-br from-primary to-primary_lt text-white text-sm font-semibold px-4 py-1.5 rounded-full whitespace-nowrap mt-0.5">
          {badge}
        </div>
      )}

      <Typography variant="h3" className="text-text text-center mb-1">
        {title}
      </Typography>

      <Typography variant="txt" className="block min-h-[40px] text-text my-4">
        {subtitle}
      </Typography>

      <div className="min-h-[90px] mb-4">
        {price}
      </div>

      {button}

      <ul className="space-y-3">
        {highlights.map((item, i) => (
          <li key={item.id || i} className="flex items-start gap-2 text-sm text-text">
            <CheckIcon className="w-4 h-4 text-success stroke-[3] shrink-0 mt-0.5" />
            <span>
              <span className="text-text_secondary">{item.name}</span>
              {item.value && (
                <span className="font-semibold text-text">{" "}{item.value}</span>
              )}
            </span>
          </li>
        ))}
      </ul>

      {children}
    </div>
  )
}
